export const getSecretFromQuery = (query: string): string => {
  let secretToken = '';

  if (query) {
    const queryString = query.split('?')[1];

    if (queryString) {
      const params = new URLSearchParams(queryString);
      secretToken = params.get('secret') ?? '';
    }
  }

  return secretToken;
};
